import CreatePlanConfig from "../config/create-plan-config.json";

function getParameterByName(name, url) {
    if (!url) url = window.location.href;
    name = name.replace(/[[]]/g, '\\$&');
    var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
        results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, ' '));
}

const GetPlanTitle = function () {
    const plan = CreatePlanConfig[getParameterByName("plan")]
    if (plan) {
        return plan.header
    }

    return "สร้างแผนกับ FINNOMENA"
}

export {
    GetPlanTitle,
}
